var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojiVerySatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 1.304,
    y2: 63.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f98900"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    gradientUnits: "userSpaceOnUse",
    x1: 14,
    x2: 50,
    y1: 41.001,
    y2: 41.001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b4b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#d0ccc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#f2edea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fffaf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#f9f5f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#e8e5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d1d1d1"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 53.275,
    y2: 37.041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#69101b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#400a10"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 32,
    x2: 32,
    xlinkHref: "#linear-gradient-2",
    y1: 38.163,
    y2: 44.885
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    gradientUnits: "userSpaceOnUse",
    x1: 52.619,
    x2: 44.688,
    y1: 9.211,
    y2: 32.611
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#ff2d44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#d41e32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#d61f33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#de2337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#eb293e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82f44"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    gradientUnits: "userSpaceOnUse",
    x1: 51.671,
    x2: 49.927,
    y1: 8.9,
    y2: 17.703
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8a95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#ff495d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2d44"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    gradientUnits: "userSpaceOnUse",
    x1: 59.035,
    x2: 57.227,
    y1: 16.73,
    y2: 21.884
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#ff565a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#ff3d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff2d44"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 48.384,
    x2: 47.197,
    xlinkHref: "#linear-gradient-7",
    y1: 14.455,
    y2: 17.84
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    gradientTransform: "matrix(-1 0 0 1 20 0)",
    x1: 8.619,
    x2: 0.688,
    xlinkHref: "#linear-gradient-5",
    y1: 9.211,
    y2: 32.611
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    gradientTransform: "matrix(-1 0 0 1 20 0)",
    x1: 7.671,
    x2: 5.927,
    xlinkHref: "#linear-gradient-6",
    y1: 8.9,
    y2: 17.703
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    gradientTransform: "matrix(.832 -.555 .555 .832 -74.259 28.539)",
    x1: 88.755,
    x2: 86.947,
    xlinkHref: "#linear-gradient-7",
    y1: 39.473,
    y2: 44.626
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    gradientTransform: "matrix(.832 -.555 .555 .832 -74.259 28.539)",
    x1: 78.104,
    x2: 76.916,
    xlinkHref: "#linear-gradient-7",
    y1: 37.198,
    y2: 40.583
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_13-_Smiling_Face_with_Heart-Eyes",
    "data-name": "13- Smiling Face with Heart-Eyes"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 63c-27.7 0-31.038-24-31-30v-2c-.038-6 3.3-30 31-30 27.7 0 31.038 24 31 30v2c.038 6-3.3 30-31 30z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.806 37.034a.986.986 0 0 1 1.19 1.1 14.5 14.5 0 0 1 -.43 2.46 34.766 34.766 0 0 1 -17.566 4.406 34.766 34.766 0 0 1 -17.566-4.409 14.5 14.5 0 0 1 -.43-2.46.986.986 0 0 1 1.19-1.1 63.8 63.8 0 0 0 16.806 2.369 63.8 63.8 0 0 0 16.806-2.366z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.918 51.76a19.918 19.918 0 0 1 -13.836 0c.329-.87 1.818-3.76 6.918-3.76s6.589 2.89 6.918 3.76z",
    fill: "#8f030e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.076 42.152a15.591 15.591 0 0 1 -5.089 6.709 19.067 19.067 0 0 1 -5.069 2.9c-.329-.871-1.818-3.761-6.918-3.761s-6.589 2.889-6.918 3.759a19.067 19.067 0 0 1 -5.069-2.9 15.591 15.591 0 0 1 -5.089-6.709 12.814 12.814 0 0 1 -.49-1.559 34.766 34.766 0 0 0 17.566 4.409 34.766 34.766 0 0 0 17.566-4.409 12.814 12.814 0 0 1 -.49 1.561z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.806 37.034a.986.986 0 0 1 1.19 1.1 14.5 14.5 0 0 1 -.43 2.46 34.766 34.766 0 0 1 -17.566 4.406 34.766 34.766 0 0 1 -17.566-4.409 14.5 14.5 0 0 1 -.43-2.46.986.986 0 0 1 1.19-1.1 63.8 63.8 0 0 0 16.806 2.369 63.8 63.8 0 0 0 16.806-2.366z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.467 12.849c-4.89-1.278-7.467 1.151-7.467 1.151s-1.334-3.451-6.224-4.729a5.734 5.734 0 0 0 -7.44 4.189 9.125 9.125 0 0 0 -.131 4.372 32.912 32.912 0 0 0 8.795 15.168 30.676 30.676 0 0 0 14.635-9.044 9.264 9.264 0 0 0 2.127-3.85c.524-1.906.595-5.979-4.295-7.257z",
    fill: "#ec3a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.467 12.849c-4.89-1.278-7.467 1.151-7.467 1.151s-1.334-3.451-6.224-4.729a5.734 5.734 0 0 0 -7.44 4.19 9.121 9.121 0 0 0 -.131 4.371 32.912 32.912 0 0 0 8.795 15.168 30.676 30.676 0 0 0 14.635-9.044 9.264 9.264 0 0 0 2.127-3.85c.524-1.906.595-5.979-4.295-7.257z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.974 11.056c5.09 1.332 6.512 4.806 6.512 4.806s2.651-2.409 7.741-1.077c3.237.847 4.4 2.805 4.685 4.609.327-2.068-.1-5.409-4.445-6.545-4.89-1.278-7.467 1.151-7.467 1.151s-1.334-3.451-6.224-4.729c-4.296-1.123-6.376 1.488-7.176 3.429 1.176-1.393 3.179-2.48 6.374-1.644z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.267 20.108a1.656 1.656 0 0 0 1.759 1.882 4.353 4.353 0 0 0 1.068-.255 2.85 2.85 0 0 0 1.906-2.658 2.872 2.872 0 0 0 -.709-1.64c-.721-.861-3.266-2.207-4.135-.877-.4.615.116 1.713.152 2.392a6.765 6.765 0 0 1 -.041 1.156z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.107 16.739c-.051.716.3 1.332.7 1.254a1.2 1.2 0 0 0 .428-.17 2.084 2.084 0 0 0 .765-1.772 2.67 2.67 0 0 0 -.283-1.093c-.289-.574-1.307-1.471-1.654-.585a4.9 4.9 0 0 0 .061 1.6 7.625 7.625 0 0 1 -.017.766z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.533 12.849c4.89-1.278 7.467 1.151 7.467 1.151s1.334-3.451 6.224-4.729a5.734 5.734 0 0 1 7.44 4.19 9.121 9.121 0 0 1 .131 4.371 32.912 32.912 0 0 1 -8.795 15.168 30.676 30.676 0 0 1 -14.635-9.044 9.264 9.264 0 0 1 -2.127-3.85c-.524-1.906-.595-5.979 4.295-7.257z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.026 11.056c-5.09 1.332-6.512 4.806-6.512 4.806s-2.651-2.409-7.741-1.077c-3.237.847-4.4 2.805-4.685 4.609-.327-2.068.1-5.409 4.445-6.545 4.89-1.278 7.467 1.151 7.467 1.151s1.334-3.451 6.224-4.729c4.3-1.123 6.381 1.488 7.179 3.433-1.179-1.397-3.182-2.484-6.377-1.648z",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.056 16.5a1.656 1.656 0 0 0 2.507.591 4.336 4.336 0 0 0 .747-.806 2.848 2.848 0 0 0 .109-3.266 2.875 2.875 0 0 0 -1.5-.971c-1.078-.317-3.942-.025-3.927 1.564.006.734 1.047 1.361 1.453 1.906a6.819 6.819 0 0 1 .611.982z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.565 18.774c.355.624.99.941 1.281.654a1.2 1.2 0 0 0 .261-.379 2.087 2.087 0 0 0 -.349-1.9 2.694 2.694 0 0 0 -.843-.753c-.558-.317-1.9-.5-1.7.432.094.43.673.924.936 1.293.149.213.287.431.414.653z",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m52.351 8.75c-5.093-4.479-11.94-6.75-20.351-6.75s-15.25 2.269-20.34 6.742l-1.32-1.5c5.466-4.806 12.753-7.242 21.66-7.242s16.2 2.439 21.672 7.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.318 53.636c-7.189-8.729-7.326-19.449-7.318-20.643v-1.993a29.772 29.772 0 0 1 .487-5.172l1.971.344a27.98 27.98 0 0 0 -.458 4.822v2.006a32.591 32.591 0 0 0 6.862 19.364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 64c-9.5 0-17.132-2.76-22.7-8.2l1.4-1.43c5.179 5.062 12.346 7.63 21.3 7.63 9.1 0 16.359-2.654 21.559-7.889 6.729-6.774 8.472-16.453 8.441-21.1v-2.121a28.16 28.16 0 0 0 -.458-4.718l1.971-.344a30.17 30.17 0 0 1 .487 5.062v2.11c.033 4.953-1.83 15.28-9.022 22.521-5.589 5.626-13.32 8.479-22.978 8.479z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 54a19.907 19.907 0 0 1 -12.61-4.355 16.561 16.561 0 0 1 -5.409-7.14 15.949 15.949 0 0 1 -.973-4.292 2.064 2.064 0 0 1 .73-1.772 1.879 1.879 0 0 1 1.729-.369 63.382 63.382 0 0 0 16.533 2.328 63.365 63.365 0 0 0 16.532-2.324 1.88 1.88 0 0 1 1.73.369 2.064 2.064 0 0 1 .73 1.772 15.912 15.912 0 0 1 -.974 4.292 16.543 16.543 0 0 1 -5.41 7.141 19.9 19.9 0 0 1 -12.608 4.35zm-17.079-16a17.572 17.572 0 0 0 .929 3.8 14.582 14.582 0 0 0 4.776 6.28 17.715 17.715 0 0 0 11.374 3.92 17.715 17.715 0 0 0 11.372-3.926 14.578 14.578 0 0 0 4.777-6.282 13.929 13.929 0 0 0 .851-3.753 66.559 66.559 0 0 1 -17 2.361 65.465 65.465 0 0 1 -17.079-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 46a35.622 35.622 0 0 1 -18.078-4.549l1.016-1.722a34.045 34.045 0 0 0 17.062 4.271 34.045 34.045 0 0 0 17.062-4.271l1.016 1.722a35.622 35.622 0 0 1 -18.078 4.549z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.985 52.114c-.277-.73-1.528-3.114-5.985-3.114s-5.708 2.384-5.985 3.114l-1.87-.709c.392-1.033 2.117-4.405 7.855-4.405s7.463 3.372 7.855 4.405z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 34a1 1 0 0 1 -.71-.3 33.417 33.417 0 0 1 -9.062-15.659 10.166 10.166 0 0 1 .144-4.849 6.743 6.743 0 0 1 8.657-4.892 10.555 10.555 0 0 1 6.312 4.254 9.726 9.726 0 0 1 7.379-.675 6.836 6.836 0 0 1 4.437 3.108 7.325 7.325 0 0 1 .57 5.382 10.329 10.329 0 0 1 -2.358 4.263 31.668 31.668 0 0 1 -15.1 9.328.992.992 0 0 1 -.269.04zm-3.173-24c-3.314 0-4.337 3.032-4.527 3.722a8.171 8.171 0 0 0 -.118 3.893 31.986 31.986 0 0 0 8.118 14.258 29.72 29.72 0 0 0 13.6-8.6 8.3 8.3 0 0 0 1.9-3.434 5.277 5.277 0 0 0 -.373-3.853 4.934 4.934 0 0 0 -3.211-2.173c-4.242-1.108-6.444.834-6.535.918a1.005 1.005 0 0 1 -1.612-.373c-.046-.116-1.255-3-5.544-4.123a6.706 6.706 0 0 0 -1.698-.235z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18 34a.992.992 0 0 1 -.269-.037 31.679 31.679 0 0 1 -15.1-9.328 10.335 10.335 0 0 1 -2.358-4.264 7.323 7.323 0 0 1 .57-5.381 6.836 6.836 0 0 1 4.437-3.108 9.735 9.735 0 0 1 7.379.675 10.552 10.552 0 0 1 6.312-4.257 6.743 6.743 0 0 1 8.657 4.9 10.166 10.166 0 0 1 .144 4.849 33.417 33.417 0 0 1 -9.062 15.651 1 1 0 0 1 -.71.3zm-9.7-20.524a9.92 9.92 0 0 0 -2.513.34 4.934 4.934 0 0 0 -3.211 2.173 5.275 5.275 0 0 0 -.376 3.852 8.3 8.3 0 0 0 1.9 3.435 29.72 29.72 0 0 0 13.6 8.6 31.986 31.986 0 0 0 8.116-14.255 8.171 8.171 0 0 0 -.118-3.893 4.772 4.772 0 0 0 -6.223-3.487c-4.289 1.121-5.5 4.007-5.547 4.129a1 1 0 0 1 -1.616.361 6.15 6.15 0 0 0 -4.012-1.255z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiVerySatisfied);
export default __webpack_public_path__ + "static/media/emojiVerySatisfied.9b42e65e26a4db895a1e008a756edd3a.svg";
export { ForwardRef as ReactComponent };